<template>
  <main class="business">
    <div v-show="checkHideContents(FirstLayer)">
			<div class="container">

				<div class="rowView pageFirstView">
					<div class="areaPageTitle">
						<h1 class="_kanji">業務内容</h1>
					</div>
					<p>
精密板金加工を主とし、製品化のために多くの工程に対応いたします。
					</p>
					<div class="workList">
						<ul>
<li @click="smoothScroll('BusinessAboutPrecision')" class="anchorLink"><p>精密板金加工</p></li>
<li><p>タレパン加工</p></li>
<li><p>曲げ加工</p></li>
<li><p>スポット溶接加工</p></li>
<li><p>溶接加工</p></li>
<li><p>組立加工</p></li>
<li><p>板金加工</p></li>
<li><p>スポット溶接</p></li>
<li><p>TIG溶接</p></li>
<li><p>レーザ溶接</p></li>
<li><p>塗装</p></li>
<li><p>メッキ</p></li>
<li><p>シルク印刷</p></li>
<li><p>彫刻</p></li>
<li><p>材料調達</p></li>
						</ul>
					</div><!--workList-->
				</div><!--rowView-->

				<section class="tagJumpTarget areaBusinessWork" id="BusinessWork">
					<div class="areaH2">
						<h2>弊社の実力</h2>
					</div>
					<div class="rowView">
						<p>
豊嶋精密工業は、創業1959年という長い歴史の中、歴代の板金職人の技術を継承して参りました。パンチング加工機を用いた加工を長年行い、豊富な知識と技術を持っております。<br>
板金加工の要でもある「曲げ」の分野でも、長い歴史の中で蓄積された独自技術・知識を駆使し、日々加工を行っております。加工をする上では様々な課題に直面致しますが、上述の独自技術と知識を用いて、課題を解決しながら、加工に取り組んでおります。<br>
また、「切断」「曲げ」工程に付随する [ カシメ ] [ スポット溶接 ] 加工も、工夫しながら御客様の御要望にお応えして参ります。<br>
<br>
現在はこの知識、技術、工夫を生かし、主に電源関連機器、業務用光学機器の製造加工を軸に、多種多様な製品製造に対応しています。
						</p>
						<div class="_block">
							<p>2025年設備拡充に伴い、よりスピーディー、パワフル、細やかな加工が可能になりました。</p>
							<dl>
<dt>「曲げ加工」：</dt><dd><router-link to="/business/equipment/EGB4010E" class="pageLink">AMADA社製 デュアルサーボベンディングマシン - EGB4010E</router-link></dd>
<dt>「板金加工」： </dt><dd><router-link to="/business/equipment/BREVIS1212AJ" class="pageLink">AMADA社製 オールラウンドファイバーレーザマシン - BREVIS-1212AJ</router-link></dd>
<dt>「溶接加工」： </dt><dd><router-link to="/business/equipment/FLW1500MT" class="pageLink">AMADA社製 ハンディファイバーレーザ溶接機 - FLW-1500MT</router-link></dd>
							</dl>
						</div>
						<ul>
<li><router-link to="/products?list=1" class="pageLinkButton pageLinkSquareButton">製作事例</router-link></li>
<li><router-link to="/business/equipment?list=1" class="pageLinkButton pageLinkSquareButton">設備一覧</router-link></li>
<li><router-link to="/business/material?list=1" class="pageLinkButton pageLinkSquareButton">取扱素材</router-link></li>
						</ul>
					</div><!--rowView-->
				</section>

				<section class="tagJumpTarget areaBusinessAbout" id="BusinessAbout">
					<div class="areaH2">
						<h2>金属加工について</h2>
					</div>
					<div class="rowView tagJumpTarget areaBusinessAboutPrecision" id="BusinessAboutPrecision">
						<h3><span>精密板金加工</span></h3>
						<div class="_block">
							<img src="/asset/images/pages/business/IMG_1630s_trim.png" class="_image" alt="精密板金加工機器">
							<p class="_text">
精密板金とは板金加工の一種であり、通常の板金加工と比較し高い加工精度・寸法公差が要求される製品を専用の機械などを使う加工です。<br>
医療機器、食品機器、電源関連装置、半導体装置や光学機器などが精密板金で加工される主な製品です。これらの製品はその用途から緻密さや精度が必要であるため、通常の板金加工ではなく、精密板金加工による加工を施す必要があります。<br>
<br>
精密板金では、その他板金加工と同様に金属板に曲げ・抜き・溶接・切断などの加工を施します。<br>
							</p>
							<div class="_block">
								<h4>精密板金の特徴</h4>
								<p>
精密板金の特徴は、<span class="markerOrange">精度の高さ</span>、<span class="markerOrange">複雑な形状の加工にも対応できる</span>、<span class="markerOrange">小ロットでの生産に向いている</span>などがあげられます。<br>
多くの精密板金加工の場合、設計から組み立て作業までを一括して行うため、筐体製作では中に組み込まれる機器や装置とのバランスを意識した加工・仕上げが可能で、見た目にも美しく仕上がります。
								</p>
							</div>
							<div class="_block">
								<h4>精密板金の長所</h4>
								<p>
精密板金ではプレス板金で加工する時よりもイニシャルコストを抑えることができます。<br>
プレス板金で加工する際は専用の金型が必要となりその分コストがかかるのですが、精密板金では汎用金型を活用することにより、コストダウンを実現することができます。
								</p>
							</div>
							<div class="_block">
								<h4>精密板金の短所</h4>
								<p>
精密板金では、金型の費用がかからないので試作や少量生産には向いていますが、数千個におよぶような大量生産には向いていません。
								</p>
							</div>
							<div class="_block">
								<h4>精密板金の選択</h4>
								<p>
1～1000個までの小～中ロットでの試作や複雑な形状の製品の加工については精密板金、単純な形状の製品の大量生産についてはプレス加工といったように、その製品・生産量によってそれぞれに適した加工を依頼するのが良いと考えられます。
								</p>
							</div>
							<div class="_block">
								<h4>精密板金の主な加工工程</h4>
								<dl>
									<dt>プログラム</dt>
									<dd>
CADデータと図面を基に、加工プログラムを組む工程です。<br>
加工順や抜き方向、選定金型によって、歩留まり率が変わります。
									</dd>
								</dl>
								<dl>
									<dt>バリ取り加工</dt>
									<dd>
主に、バリ取り機を使用致しますが、取り切れないバリはヤスリによる手作業にて加工します。
									</dd>
								</dl>
								<dl>
									<dt>ボール盤・タップ加工</dt>
									<dd>
ネジ穴（タップ加工）や穴の面取り（サラ加工）を、ボール盤やタッピング盤を使用し、加工します。
									</dd>
								</dl>
								<dl>
									<dt>曲げ加工</dt>
									<dd>
製品の立体的な形を成型する加工です。
プレスブレーキという機械で加工しますが、加工者の技術力によって製品の出来が左右されます。
									</dd>
								</dl>
								<dl>
									<dt>組立加工</dt>
									<dd>
部品と部品をネジやリベット等で固定し一つの製品に組上げます。
									</dd>
								</dl>
								<dl>
									<dt>スポット溶接</dt>
									<dd>
複数の金属板を電極で挟み込み、電流を流すことにより抵抗熱で金属板が加熱され、金属板と金属板を接合する加工です。<br>
一般的な溶接に比べると、低コストで出来るが、電極の選定や加工条件の選定が必須になります。
									</dd>
								</dl>
								<dl>
									<dt>溶接加工</dt>
									<dd>
金属同士を溶解してつなぎ合わせる加工です。<br>
当社では主にＴｉｇ溶接、ガス溶接、半自動溶接を実施しております。<br>
※新たにファイバーレーザ溶接が可能になりました。
									</dd>
								</dl>
								<dl>
									<dt>カシメ加工</dt>
									<dd>
板と部品を塑性変形を利用して圧着させる加工です。<br>
リベット加工、手カシメなど用途によって加工方法が異なります。
									</dd>
								</dl>
								<dl>
									<dt>脱脂</dt>
									<dd>
製品加工時に付着した汚れや機械油等を洗い流す工程です。
									</dd>
								</dl>
							</div>

						</div><!--_block-->
					</div><!--rowView-->
				</section>

			</div><!--container-->
    </div><!--v-show-->
    <router-view></router-view>
  </main>
</template>

<script>
export default {
  name: 'business',
  components:{
  },
  data() {
    return {
			pageTitle:"業務内容",
			description:"電源関連機器、業務用光学機器の製造加工を軸に、多種多様な金属加工を請け負います。",
			keywords:"業務内容 金属加工について 精密板金について",
			ogType:"article",
    }
  },
  computed: {
		isUrl:function() {
			return window.location.href
		},
  },
  mounted: function() {
/*子が呼び出されているときは、以下をセットしないようにしないといけない*/
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', '')
	
/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			this.$store.commit('updateLinkCanonical', '')
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
		}
  },
  updated: function() {console.log("updated "+this.$options.name)
/*子が呼び出されているときは、以下をセットしないようにしないといけない*/
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			this.$store.commit('updateLinkCanonical', '')
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
		}
  },
  methods: {
  },
}
</script>
<style>
</style>
